import React, {useState} from "react";
import styles from "./Collapsable.module.scss";

const Collapsable = ({ children, title, disabled = false, executeScroll }) => {

    const [expanded, setExpanded] = useState(false);

    const handleToggleCollapse = () => {
        if (executeScroll) {
            executeScroll();
        }
        setExpanded(!expanded);
    }

    return (
        <div className={`${styles.Collapsable} ${expanded && styles.expanded} ${disabled && styles.disabled}`}>
            <div className={`d-flex align-items-center justify-content-between  ${styles.header}`}>
                <div className={styles.title}>
                    { title }
                </div>
                <div onClick={handleToggleCollapse} className={styles.icon}>
                    <i>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.5 4.25L6 7.75L9.5 4.25" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </i>
                </div>
            </div>
            <div className={styles.content}>
                { children }
            </div>
        </div>
    )
}

export default Collapsable;